import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

const MISSING_CHART_VALUE = "N/A"

// Recharts tooltip formatters receive `ValueType | undefined`, so a value may be
// absent, a string, or a range array. Anything not finite is reported as missing
// rather than coerced to zero, which would read as a real measurement.
function toFiniteNumber(value: unknown): number | null {
  if (value === null || value === undefined || value === "") return null
  if (Array.isArray(value)) return null
  const parsed = typeof value === "number" ? value : Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function formatChartNumber(value: unknown): string {
  const parsed = toFiniteNumber(value)
  return parsed === null ? MISSING_CHART_VALUE : parsed.toLocaleString()
}

export function formatChartCurrency(value: unknown): string {
  const parsed = toFiniteNumber(value)
  return parsed === null ? MISSING_CHART_VALUE : `$${parsed.toFixed(2)}`
}
